import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useMemo, useState } from 'react';
import { getTimeActivitiesServiceOptions } from '~/business-logic/billServiceSelector';
import { BillingType } from '~/components/BillModal/BillClientModal.types';
import { getUnusedTimeActivities } from '~/components/BillModal/utils/BillClientModal.utils';
import { createTimeActivityServiceItem } from '~/components/BillModal/utils/lineItem.utils';
import { useStore, useStoreActions } from '~/contexts';
import { useQboTimeActivities } from '~/hooks/reactQuery/queries/useQboTimeActivities';
import { useLocaleKeys } from '~/i18n';
import { getAccountingDetails } from '~/integrations/Accounting/accounting.utils';
import { TimeActivitiesModel } from '~/models';
import { costDisplayTextsPath } from '~/models/service-cost/selectors';
import { selectors } from '~/store/state-selectors';
import { Accounting } from '~/types/api.model';
import { billingPeriodTextsPath } from '~/utils/billing-period-text';
export const useTimeActivitiesController = (param)=>{
    let { relationship, controlData, defaultItem, billItems, items, setRelationship } = param;
    var _serviceOptions_find;
    const allowTimeActivities = useStore(selectors.integration.allowTimeActivities);
    const { logBI } = useStoreActions();
    const vendorId = useStore(selectors.user.businessId);
    const userId = useStore(selectors.user.id);
    const { t: costDisplayTexts } = useLocaleKeys(costDisplayTextsPath);
    const { t: billingTexts } = useLocaleKeys(billingPeriodTextsPath);
    const { data: timeActivitiesData, refresh: refreshTimeActivities, isFetching } = useQboTimeActivities(relationship.id);
    const timeActivities = useMemo(()=>timeActivitiesData !== null && timeActivitiesData !== void 0 ? timeActivitiesData : new TimeActivitiesModel(), [
        timeActivitiesData
    ]);
    const { fullName: accountingName } = getAccountingDetails(Accounting.QBO);
    const serviceOptions = useMemo(()=>{
        if (!allowTimeActivities) return [];
        return getTimeActivitiesServiceOptions({
            services: relationship.services,
            controlData,
            defaultServiceId: defaultItem.type === BillingType.Service ? defaultItem.service.id : undefined,
            costDisplayTexts,
            periodTexts: billingTexts.periods
        });
    }, [
        allowTimeActivities,
        controlData,
        defaultItem,
        relationship.services,
        costDisplayTexts,
        billingTexts
    ]);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [selectedServiceId, setSelectedServiceId] = useState(undefined);
    const selectedService = (_serviceOptions_find = serviceOptions.find((option)=>option.id === selectedServiceId)) !== null && _serviceOptions_find !== void 0 ? _serviceOptions_find : serviceOptions[0];
    const fullSelectedService = relationship.services.find((service)=>service.id === (selectedService === null || selectedService === void 0 ? void 0 : selectedService.id));
    const selectedServiceTimeActivities = useMemo(()=>timeActivities.getTimeActivitiesForService(selectedService === null || selectedService === void 0 ? void 0 : selectedService.id), [
        timeActivities,
        selectedService
    ]);
    const unusedTimeActivities = useMemo(()=>getUnusedTimeActivities(items, selectedServiceTimeActivities), [
        items,
        selectedServiceTimeActivities
    ]);
    const isSelectedServiceMapped = !!(fullSelectedService === null || fullSelectedService === void 0 ? void 0 : fullSelectedService.integrations.qboIntegratedId());
    const onAddSingle = (timeActivity)=>{
        if (!fullSelectedService) return;
        logBI(12016, {
            vendorId,
            userId
        });
        billItems.removeFirstItemIfUntouched();
        billItems.appendItem(createTimeActivityServiceItem(fullSelectedService, timeActivity));
    };
    const onAddAll = ()=>{
        if (!fullSelectedService) return;
        logBI(12015, {
            vendorId,
            userId
        });
        billItems.removeFirstItemIfUntouched();
        selectedServiceTimeActivities.forEach((timeActivity)=>{
            billItems.appendItem(createTimeActivityServiceItem(fullSelectedService, timeActivity));
        });
    };
    const onRefresh = ()=>{
        logBI(12019, {
            vendorId,
            userId
        });
        return refreshTimeActivities();
    };
    const onServiceMapped = async (param)=>{
        let { serviceTemplateId, accountingItemId } = param;
        const updatedServices = relationship.services.map((service)=>service.serviceTemplateId === serviceTemplateId ? _object_spread_props(_object_spread({}, service), {
                integrations: service.integrations.setQboIntegratedId(accountingItemId)
            }) : service);
        setRelationship((old)=>_object_spread_props(_object_spread({}, old), {
                services: updatedServices
            }));
        await refreshTimeActivities();
    };
    return {
        allowTimeActivities,
        timeActivities,
        serviceOptions,
        selectedService: selectedService !== null && selectedService !== void 0 ? selectedService : {
            id: '',
            name: '',
            costString: ''
        },
        fullSelectedService,
        unusedTimeActivities,
        accountingName,
        isSelectedServiceMapped,
        showAddAll: isSelectedServiceMapped && unusedTimeActivities.length > 0,
        isRefreshing: isFetching,
        isDrawerOpen,
        hasSelectableServices: serviceOptions.length > 0,
        openDrawer: ()=>setIsDrawerOpen(true),
        closeDrawer: ()=>setIsDrawerOpen(false),
        onSelectService: (option)=>setSelectedServiceId(option.id),
        onAddSingle,
        onAddAll,
        onRefresh,
        onServiceMapped
    };
};
